import { MenuItem } from '@mui/material';
import React, { useMemo } from 'react';
import { UserModel } from '../../../../models';
import { useGetPublishers } from '../../../../utils/hooks/useGetPublishers';
import { GtSelect } from '../../../gt-select/GtSelect';

interface PublishersFilterProps {
  className: string;
  filtersValue: string;
  onFiltersChange?: (user: string) => void;
}

export function PublishersFilter({
  filtersValue,
  className,
  onFiltersChange,
}: PublishersFilterProps) {
  const data = useGetPublishers();

  const options = useMemo(() => {
    if (!data) {
      return [];
    }

    const users = data.map((item): Partial<UserModel> => item);

    return [
      {
        code: '-',
        name: 'All hosts',
      },
      ...users,
    ];
  }, [data]);

  if (!data) {
    return null;
  }

  const onFilterChanged = (event) => {
    const { value } = event.target;

    onFiltersChange(value === '-' ? null : value);
  };

  return (
    <GtSelect
      fullWidth
      className={className}
      variant="outlined"
      size="small"
      value={filtersValue || '-'}
      placeholder="Select publisher"
      onChange={onFilterChanged}
      name="publisher"
      label="Filter by publisher"
      inputProps={{
        name: 'publisherFilter',
        id: 'publisherFilter',
      }}
    >
      {(options || []).map(({ name, code }) => (
        <MenuItem key={code} value={code}>
          {name}
        </MenuItem>
      ))}
    </GtSelect>
  );
}
